import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  useAddTicketToAppleWalletMutation,
  useAddTicketToGoogleWalletMutation,
  useGetTicketsByBookingIdMutation,
} from "../../Redux/apis/ApiSlice";
import {
  Card,
  Row,
  Col,
  Spin,
  Typography,
  Alert,
  Divider,
  Button,
  notification,
} from "antd";
import { DownloadOutlined } from "@ant-design/icons";
// import DownloadIcon from "@mui/icons-material/Download";
import Template1 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/TicketTemplate/Template1";
import Ticket5 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/TicketTemplate/Ticket5";
import Ticket6 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/TicketTemplate/Ticket6";
import Ticket7 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/TicketTemplate/Ticket7";
import Ticket8 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/TicketTemplate/Ticket8";
import Ticket9 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/TicketTemplate/Ticket9";
import Band1 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/BandTemplate/Band1";
import Band2 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/BandTemplate/Band2";
import Band3 from "../../components/MyEvents/AddEvent/CreateTicket/Templates/BandTemplate/Band3";
import moment from "moment";
import { toPng } from "html-to-image";
import html2canvas from "html2canvas";
import GoogleWallet from "../../Images/google_wallet_logo.png";

import {
  Autocomplete,
  Box,
  Checkbox,
  Grid,
  Modal,
  TextField,
} from "@mui/material";
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
  WhatsappShareButton,
  WhatsappIcon,
} from "react-share";
import jsPDF from "jspdf";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import AppleWallet from "../../Images/Apple_Wallet.svg";

const { Title, Text } = Typography;

dayjs.extend(duration);

const TicketsDetails = () => {
  const [emails, setEmails] = useState([]);
  const location = useLocation();
  const isAndroid = /Android/i.test(navigator.userAgent);
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  const isSmallScreen = window.innerWidth <= 560;
  const bookingId = location.state?.bookingId;
  const eventId = location.state?.eventId;
  const [modalOpen, setModalOpen] = useState(false);
  const [shareableLink, setShareableLink] = useState("");
  const [selectedTickets, setSelectedTickets] = useState([]);
  const [shareableLinks, setShareableLinks] = useState([]);
  const [token, setToken] = useState(null);
  const accessToken = JSON.parse(localStorage.getItem("accessToken"));
  const userData = JSON.parse(localStorage.getItem("userData"));
  const userName = userData?.name;
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [loadingShare, setLoadingShare] = useState(false);
  const [loadingFetchContacts, setLoadingFetchContacts] = useState(false);
  const [addTicketToGoogleWallet, { isLoading: isAddingToGoogleWallet }] =
    useAddTicketToGoogleWalletMutation();
  const [addTicketToAppleWallet, { isLoading: isAddingToAppleWallet }] =
    useAddTicketToAppleWalletMutation();
  const [walletLink, setWalletLink] = useState("");
  let authtoken = localStorage.getItem("authToken");

  const [getTicketsByBookingId, { data, isLoading, isError, error }] =
    useGetTicketsByBookingIdMutation();

  useEffect(() => {
    if (bookingId && eventId) {
      getTicketsByBookingId({ bookingId, eventId });
    }
  }, [bookingId, eventId, getTicketsByBookingId]);

  const ticketsRef = useRef();
  const ticketRefs = useRef([]);

  const eventDetails = data?.data?.eventDetails;
  const tickets = data?.data?.tickets;
  const ticketTemplate = eventDetails?.ticket?.[0]?.ticketTemplate;
  // Toggle ticket selection
  const toggleTicketSelection = (index) => {
    setSelectedTickets((prevSelected) =>
      prevSelected.includes(index)
        ? prevSelected.filter((i) => i !== index)
        : [...prevSelected, index]
    );
  };

  // Handle sending emails
  const handleSendEmails = (recipients) => {
    if (!recipients || recipients.length === 0) return;

    const recipientEmails = recipients.join(",");
    const emailSubject = encodeURIComponent("Check out these tickets!");
    const emailBody = encodeURIComponent(encodedMessage);

    window.open(
      `mailto:${recipientEmails}?subject=${emailSubject}&body=${encodedMessage}`
    );

    notification.success({
      message: `Message sent to ${recipients.length} recipient(s)!`,
    });
  };

  const handleAddToGoogleWallet = async (ticketId) => {
    try {
      const response = await addTicketToGoogleWallet({
        userName: userName,
        ticketId: ticketId,
      });
      setWalletLink(response?.data?.saveUrl);
      window.open(response?.data?.saveUrl, "_blank");
    } catch (error) {
      console.error("Error adding ticket to Google Wallet:", error);
    }
  };
  const handleAddToAppleWallet = async (ticketId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/booking/apple-wallet`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authtoken}`,
          },
          body: JSON.stringify({
            userName,
            ticketId,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to generate Apple Wallet pass");
      }

      const blob = await response.blob();

      // Create a temporary download link
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `ticket_${ticketId}.pkpass`;
      document.body.appendChild(a);
      a.click();

      // Cleanup
      a.remove();
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Error adding ticket to Apple Wallet:", error);
    }
  };

  // Upload file to S3
  const uploadFileToS3 = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/upload`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error("File upload failed");
      }

      const result = await response.json();
      return result.Location;
    } catch (error) {
      console.error("Error uploading file:", error);
      throw error;
    }
  };
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  // Fetch contacts from Google API
  const fetchContacts = async () => {
    setLoadingFetchContacts(true);
    try {
      if (!accessToken || emails.length === 0) {
        window.google.accounts.oauth2
          .initTokenClient({
            client_id: clientId,
            scope: "https://www.googleapis.com/auth/contacts.readonly",
            callback: async (response) => {
              if (response.access_token) {
                localStorage.setItem(
                  "accessToken",
                  JSON.stringify(response.access_token)
                );
                setToken(response.access_token);

                const contactResponse = await fetch(
                  `https://people.googleapis.com/v1/people/me/connections?pageSize=1000&personFields=names,emailAddresses`,
                  {
                    headers: {
                      Authorization: `Bearer ${response.access_token}`,
                    },
                  }
                );

                if (!contactResponse.ok) {
                  throw new Error("Failed to fetch contacts");
                }

                const data = await contactResponse.json();
                const contactsWithEmails = data?.connections?.filter(
                  (contact) => contact.emailAddresses
                );
                const emailList = contactsWithEmails?.map(
                  (contact) => contact.emailAddresses[0]?.value
                );

                if (emailList && emailList.length > 0) {
                  setEmails(emailList);
                  notification.success({
                    message: "Contacts fetched successfully!",
                  });
                } else {
                  setEmails([]);
                  notification.info({
                    message: "No contacts found in your network!",
                  });
                }
              } else {
                throw new Error("Error retrieving access token");
              }
            },
          })
          .requestAccessToken();
      }
    } catch (error) {
      console.error("Error fetching contacts:", error);
      notification.error({
        message: "Failed to fetch contacts!",
        // description: error.message,
      });
    } finally {
      setLoadingFetchContacts(false);
    }
  };

  // Generate shareable link for a ticket
  const handleShareableLink = async (ticketRef, ticketIndex) => {
    if (!ticketRef.current) {
      console.error("ticketRef.current is null or undefined.");
      return;
    }
    try {
      const dataUrl = await toPng(ticketRef.current);
      const blob = await fetch(dataUrl).then((res) => res.blob());
      const file = new File([blob], `ticket-${ticketIndex}.png`, {
        type: "image/png",
      });
      const s3Url = await uploadFileToS3(file);
      setShareableLink(s3Url);
      setModalOpen(true);
    } catch (error) {
      console.error("Error generating shareable link:", error);
    }
  };

  // Share selected tickets
  const handleShareSelectedTickets = async () => {
    const links = [];
    try {
      setLoadingShare(true);
      for (const index of selectedTickets) {
        const ticketRef = ticketRefs.current[index];
        if (!ticketRef.current) continue;

        const dataUrl = await toPng(ticketRef.current);
        const blob = await fetch(dataUrl).then((res) => res.blob());
        const file = new File([blob], `ticket-${index}.png`, {
          type: "image/png",
        });
        const s3Url = await uploadFileToS3(file);
        links.push(s3Url);
      }
      setShareableLinks(links);
      setModalOpen(true);
    } catch (error) {
      console.error("Error sharing selected tickets:", error);
    } finally {
      setLoadingShare(false);
    }
  };

  // Generate encoded message for sharing
  const handleShareLinks = () => {
    const emailBody = shareableLinks.join("\n");
    return encodeURIComponent(`Check out these tickets:\n\n${emailBody}`);
  };

  const encodedMessage = handleShareLinks();

  // Render ticket template based on template ID
  const renderTemplate = (ticketData, ticketType, index) => {
    const ticketRef = React.createRef();
    ticketRefs.current[index] = ticketRef;

    const templates = {
      7: Template1,
      8: Ticket5,
      9: Ticket6,
      10: Ticket7,
      11: Ticket8,
      12: Ticket9,
      13: Band1,
      14: Band2,
      default: Band3,
    };

    const SelectedTemplate = templates[ticketTemplate] || templates.default;

    return (
      <>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            position: "relative",
          }}
        >
          <div
            ref={ticketRef}
            className="ticket-container"
            style={{
              paddingBottom: "10px",
              position: "relative",
              display: "inline-block",
              width: "100%",
              overflow: "auto hidden",
            }}
          >
            <SelectedTemplate
              ticket={ticketData}
              type={ticketType}
              image={eventDetails?.ticket?.[0].ticketPhoto}
            />
          </div>
          <Button
            className="download-button"
            type="primary"
            shape="square"
            icon={<DownloadOutlined />}
            disabled={loadingDownload}
            onClick={() => downloadTicket(ticketRef)}
            style={{
              display: "flex", // Hidden by default
              position: "absolute",
              top: 10,
              right: 50,
              width: "35px",
              height: "35px",
              padding: "4px",
              zIndex: 10,
              color: "white",
              border: "none",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "18px",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#061F44"; // New hover color
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#1677FF"; // Back to default
            }}
          />

          <Checkbox
            onChange={() => toggleTicketSelection(index)}
            checked={selectedTickets.includes(index)}
          >
            Select
          </Checkbox>
        </Box>
      </>
    );
  };

  // Download individual ticket
  const downloadTicket = async (ticketRef) => {
    if (!ticketRef.current) return;

    try {
      setLoadingDownload(true);

      // Find the download button inside ticketRef
      const downloadButton =
        ticketRef.current.querySelector(".download-button");

      // Temporarily hide the button
      if (downloadButton) {
        downloadButton.style.display = "none";
      }

      // Capture ticket without the button
      const dataUrl = await toPng(ticketRef.current);

      // Restore the button after capturing
      if (downloadButton) {
        downloadButton.style.display = "block";
      }

      // Create and trigger the download link
      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = "Ticket.png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      notification.error({
        message: "Error downloading ticket. Please retry.",
      });

      console.error("Error downloading ticket:", error);
    } finally {
      setLoadingDownload(false);
    }
  };

  // Organize ticket data
  const organizeTicketData = (ticket) => ({
    title: eventDetails.eventName,
    organizer: ticket.booking.bookerName,
    date: dayjs(eventDetails.startDateTime).format("MM/DD/YYYY"),
    time: dayjs(eventDetails.startDateTime).format("hh:mm A"),
    code: ticket.code,
    location: eventDetails.location,
    price: ticket.price,
    qrCode: ticket.qrCode,
    bgColor: eventDetails.ticket?.[0]?.color,
    ticketName: ticket.ticketName || "Unnamed Ticket",
  });

  // Download all tickets as PDF

  const downloadAllTickets = async () => {
    setLoadingDownload(true);

    try {
      const ticketsContainers = document.querySelectorAll(".ticket-container"); // Select all ticket elements
      if (!ticketsContainers.length) {
        throw new Error("No tickets found");
      }

      // Create a new PDF instance
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      let yPos = 10;

      for (let i = 0; i < ticketsContainers.length; i++) {
        const ticket = ticketsContainers[i];
        const dataUrl = await toPng(ticket, { cacheBust: true });
        const imgProps = pdf.getImageProperties(dataUrl);
        const imgWidth = pdfWidth - 20;
        const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

        if (yPos + imgHeight > pdfHeight - 10) {
          pdf.addPage();
          yPos = 10;
        }
        pdf.addImage(dataUrl, "PNG", 10, yPos, imgWidth, imgHeight);
        yPos += imgHeight + 10;
      }

      pdf.save("All_Tickets.pdf");
    } catch (error) {
      console.error("Error generating PDF:", error);
      notification.error({
        message: "Error generating PDF. Please retry",
      });
    } finally {
      setLoadingDownload(false);
    }
  };

  const XIcon = () => (
    <img
      src="https://upload.wikimedia.org/wikipedia/commons/5/53/X_logo_2023_original.svg"
      alt="X (Twitter) logo"
      width={32}
      height={32}
      style={{ borderRadius: "50%" }}
    />
  );

  return (
    <div style={{ padding: "20px", maxWidth: "1200px", margin: "0 auto" }}>
      <Title level={2}>Tickets Details</Title>

      {isLoading && (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <Spin size="large" />
        </div>
      )}

      {isError && (
        <Alert
          type="error"
          message="Error"
          description={
            error?.data?.message ||
            "Failed to fetch tickets. Please try again later."
          }
          showIcon
          style={{ marginBottom: "20px" }}
        />
      )}

      {eventDetails && (
        <Card
          title="Event Details"
          style={{
            marginBottom: "20px",
            borderRadius: "10px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={8}>
              {eventDetails?.eventPhoto?.[0] ? (
                <img
                  alt="Event"
                  src={eventDetails.eventPhoto[0]}
                  style={{
                    width: "100%",
                    borderRadius: "10px",
                    objectFit: "contain",
                    height: "300px",
                  }}
                />
              ) : (
                <div
                  style={{
                    width: "100%",
                    height: "300px",
                    borderRadius: "10px",
                    background: "#061f44",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "24px",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  Booked Tickets
                </div>
              )}
            </Col>
            <Col xs={24} sm={16}>
              <Title level={3}>Event Name: {eventDetails?.eventName}</Title>

              <Box
                sx={{
                  mb: 1,
                  display: "flex",
                  gap: 1,
                  flexDirection: { xs: "column", sm: "row" },
                }}
              >
                <strong>Location:</strong>
                <Text>{eventDetails.location}</Text>
              </Box>

              <Box
                sx={{
                  mb: 1,
                  display: "flex",
                  gap: 1,
                  flexDirection: { xs: "column", sm: "row" },
                }}
              >
                <strong>Start Date & Time:</strong>
                <Text>
                  {dayjs(eventDetails?.startDateTime).isValid()
                    ? dayjs(eventDetails.startDateTime).format(
                        "MM/DD/YYYY hh:mm A"
                      )
                    : ""}
                </Text>
              </Box>

              <Box
                sx={{
                  mb: 1,
                  display: "flex",
                  gap: 1,
                  flexDirection: { xs: "column", sm: "row" },
                }}
              >
                <strong>End Date & Time:</strong>
                <Text>
                  {dayjs(eventDetails?.endDateTime).isValid()
                    ? dayjs(eventDetails.endDateTime).format(
                        "MM/DD/YYYY hh:mm A"
                      )
                    : ""}
                </Text>
              </Box>

              <Box
                sx={{
                  mb: 1,
                  display: "flex",
                  gap: 1,
                  flexDirection: { xs: "column", sm: "row" },
                }}
              >
                <strong>Organization:</strong>
                <Text>{eventDetails.organizationName}</Text>
              </Box>

              <Box
                sx={{ mb: 1, display: "flex", gap: 1, flexDirection: "column" }}
              >
                <strong>Description:</strong>
                <Typography style={{ textAlign: "justify", hyphens: "auto" }}>
                  {eventDetails.description}
                </Typography>
              </Box>
            </Col>
          </Row>
        </Card>
      )}

      <Divider />

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          columnGap: "10px",
          rowGap: { xs: "10px", sm: "0" },
          marginBottom: "20px",
        }}
      >
        <Button
          type="primary"
          onClick={downloadAllTickets}
          disabled={loadingDownload}
          style={{ marginBottom: { xs: "10px", sm: "0" } }}
        >
          Download All Tickets
        </Button>
        <Button
          // type="primary"
          disabled={selectedTickets.length === 0}
          onClick={handleShareSelectedTickets}
          loading={loadingShare}
          style={{
            backgroundColor:
              selectedTickets.length === 0 ? "#638ebf" : "#1677FF",
            color: "white",
          }}
        >
          Share Selected Tickets
        </Button>
      </Box>
      <Typography>{loadingDownload ? "Downloading..." : ""}</Typography>

      <Box
        ref={ticketsRef}
        sx={{
          position: "relative",
          pr: 1,
          width: { xs: "100vw", md: "100%" },
          overflow: { xs: "auto", md: "unset" },
        }}
      >
        <Row gutter={[16, 16]}>
          {tickets?.length ? (
            tickets.map((ticket, index) => (
              <Col
                key={index}
                xs={24}
                sm={18}
                style={{
                  minWidth: "600px", // Set fixed width for small screens
                  maxWidth: "1200px", // Optional: Prevents too large tickets
                  flexShrink: 0, // Ensures tickets don’t shrink
                  overflow: "auto hidden",
                }}
              >
                {renderTemplate(
                  organizeTicketData(ticket),
                  ticket.ticketType,
                  index
                )}
                {/* {isAndroid && ( */}
                <Box sx={{ display: "flex", gap: 1 }}>
                  <div
                    className="py-6"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleAddToGoogleWallet(ticket.ticketId)}
                  >
                    <div className="max-w-2xl mx-auto sm:px-6 lg:px-8">
                      <div className="bg-gray-100 overflow-hidden shadow-sm sm:rounded-lg">
                        <div className="p-10">
                          <img
                            width={150}
                            src={GoogleWallet} // Make sure this file is in your `public/` folder
                            alt="Add to Google Wallet"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* )} */}
                  {/* {isSmallScreen && ( */}
                  <Box
                    sx={{ cursor: "pointer" }}
                    onClick={() => handleAddToAppleWallet(ticket.ticketId)}
                  >
                    <img
                      width={140}
                      src={AppleWallet}
                      alt="Add to Apple Wallet"
                    />
                  </Box>
                  {/* )} */}
                </Box>
              </Col>
            ))
          ) : (
            <Col span={24}>
              <Alert
                type="info"
                message="No Tickets Found"
                description="There are no tickets available for this booking."
                showIcon
              />
            </Col>
          )}
        </Row>
      </Box>

      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby="shareable-link-title"
        aria-describedby="shareable-link-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "300px", md: "400px" },
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 1,
            textAlign: "center",
            borderRadius: "8px",
          }}
        >
          <Typography
            id="shareable-link-title"
            variant="h6"
            component="h2"
            sx={{ mb: 2 }}
          >
            Shareable Link
          </Typography>
          {shareableLinks.length >= 0 ? (
            <div style={{ marginBottom: "10px" }}>
              <div
                style={{
                  marginTop: "10px",
                  display: "flex",
                  gap: "10px",
                  justifyContent: "center",
                }}
              >
                <WhatsappShareButton
                  url={encodedMessage}
                  title={"Check out the tickets:"}
                  separator=": "
                >
                  <WhatsappIcon size={32} round />
                </WhatsappShareButton>

                <FacebookShareButton
                  url={encodedMessage}
                  quote={"Check out the tickets:"}
                >
                  <FacebookIcon size={32} round />
                </FacebookShareButton>

                <TwitterShareButton
                  url={encodedMessage}
                  title={"Check out the tickets:"}
                >
                  {/* <TwitterIcon size={32} round /> */}
                  <XIcon />
                </TwitterShareButton>

                <LinkedinShareButton
                  url={encodedMessage}
                  summary={"Check out the tickets:"}
                >
                  <LinkedinIcon size={32} round />
                </LinkedinShareButton>

                {/* Email */}
                <a
                  href={`mailto:?subject=Check out these tickets!&body=${encodedMessage}`}
                  style={{ textDecoration: "none" }}
                  title="Share via Email"
                >
                  <img
                    src="https://img.icons8.com/ios-filled/50/000000/email.png" // Example email icon
                    alt="Email Icon"
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                    }}
                  />
                </a>

                {/* Gmail */}
                <a
                  href={`mailto:?subject=Check out these tickets!&body=${encodedMessage}`}
                  style={{ marginLeft: "10px" }}
                >
                  <img
                    src="https://cdn-icons-png.flaticon.com/512/281/281769.png"
                    alt="Gmail"
                    style={{ width: 32, height: 32, borderRadius: "50%" }}
                  />
                </a>
              </div>
            </div>
          ) : (
            // ))
            <Typography variant="body2" color="textSecondary">
              No links available.
            </Typography>
          )}
          {emails && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: "20px",
                marginBottom: "20px",
              }}
            >
              <Button
                // disabled={selectedEmails.length === 0}
                onClick={fetchContacts}
              >
                Fetch My Contacts
              </Button>
            </Box>
          )}

          {/* Multi-Select Autocomplete for Emails */}
          <Grid item sx={{ display: "flex" }}>
            <Autocomplete
              sx={{ width: "100%" }}
              id="email-selector"
              multiple
              freeSolo
              options={emails} // Suggestions from the emails array
              value={selectedEmails}
              onChange={(event, newValue) => setSelectedEmails(newValue)} // Update selected emails
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Email Addresses"
                  variant="outlined"
                  fullWidth
                />
              )}
            />
          </Grid>

          {/* Send Button */}
          <Box sx={{ marginTop: "1rem" }}>
            <Button
              sx={{ marginTop: "1rem" }}
              onClick={() => handleSendEmails(selectedEmails)}
              disabled={selectedEmails.length === 0}
            >
              Send
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default TicketsDetails;
